module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAElBMVEVHcEz///////////////////+IGTx/AAAABXRSTlMAj0jOd5LAYvsAAADtSURBVEjH7ZYxEgIhDEVRL2BDb+MR7G08gOPk/lfRwV03QD68wsJCqp2E/4aFkE9K//Eae5K6HeWkfF0+dnZXc7bU2Uyhstlpna5QPpMVyicUqo4LVB2OUW00RLXBCNXHAlQf6mURvNNFy2yF8Q83ynjraqk6hEqrjtOLdWE4tawLJ9cgp9egDTACfQgj0IoYgxbGGPSGzEAFdZmACmoKKqgZKKWD2SN9g4TWRP4O7RPZcXR2pApQPZHKRDVObgu6d+QGo15AugrqT6TToZ5Jui/q48QRkLcQl0J+R5wTeTB0c/AuQC8M9lb5tfEEFgBkOWIDjUsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/views/concierge/images/concierce_ico_close.png
// module id = 6A10
// module chunks = 0